import { actionLogActionTypes as actionTypes } from '../ActionTypes/actionLogActionTypes';
import { apiFetch, type ApiError } from '../Utils/httpClient';
import { apiThunk } from '../Utils/apiThunk';
import apiActions from './apiActions';
import type { components } from '../Types/api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyDispatch = any;

type UserActionLog = components['schemas']['Cockpit.Models.UserActionLog.UserActionLogModel'];
type EmailModel = components['schemas']['Cockpit.Models.Email.EmailModel'];
type SystemActionLog = components['schemas']['Cockpit.Models.SystemActionLog.SystemActionLogModel'];

const actionLogActions = {
    getCustomerActionLog(customerNumber: string) {
        return (dispatch: AnyDispatch) =>
            dispatch(
                apiThunk<UserActionLog[]>(`/api/actionlog/GetCustomerLogs/${encodeURIComponent(customerNumber)}`, {
                    loadingKey: 'customerActionLogs',
                })
            ).then((data: UserActionLog[] | null) => {
                if (data) dispatch({ type: actionTypes.STORE_CUSTOMER_ACTIONLOGS, data });
            });
    },

    getMyActionLog() {
        return (dispatch: AnyDispatch) =>
            apiFetch<UserActionLog[]>('/api/actionlog/GetAllForUser')
                .then((data) => {
                    if (data) dispatch({ type: actionTypes.STORE_MY_ACIONLOGS, data });
                })
                .catch((error: unknown) => {
                    dispatch(apiActions.apiErrorOccurred(error as ApiError));
                });
    },

    getFormFromEmailActionLog(emailActionLogId: number, callback: (data: EmailModel) => void) {
        return (dispatch: AnyDispatch) =>
            dispatch(apiThunk<EmailModel>(`/api/actionlog/GetEmailFromActionLog/${emailActionLogId}`)).then((data: EmailModel | null) => {
                if (data) callback(data);
            });
    },

    getSystemActionLogs() {
        return (dispatch: AnyDispatch) =>
            dispatch(apiThunk<SystemActionLog[]>('/api/actionlog/GetSystemActionLogs', { loadingKey: 'actionLogs' })).then((data: SystemActionLog[] | null) => {
                if (data) dispatch({ type: actionTypes.STORE_SYSTEM_ACTIONLOGS, data });
            });
    },
};

export default actionLogActions;
